import {useDispatch} from "react-redux";

import {useAppSelector} from "../../store/hooks";
import {closeFlow, nextStep, RegistrationFlowStep, RegistrationFlowVariant, skipCurrentStep} from "../state/registration_flow_slice";
import {RegistrationCompletionModal} from "./registration_flow/RegistrationCompletionModal";
import {RegistrationPreferencesModal} from "./registration_flow/RegistrationPreferencesModal";
import {RegistrationThankYouFavoritesModal} from "./registration_flow/RegistrationThankYouFavoritesModal";
import {RegistrationThankYouModal} from "./registration_flow/RegistrationThankYouModal";

export const RegistrationFlow = () => {
    const dispatch = useDispatch();
    const flowState = useAppSelector((state) => state.registrationFlow);

    if (!flowState.isActive) {
        return null;
    }

    const handleNextStep = () => {
        dispatch(nextStep());
    };

    const handleSkipStep = () => {
        dispatch(skipCurrentStep());
    };

    const handleCloseFlow = () => {
        dispatch(closeFlow());
    };

    return (
        <>
            {flowState.currentStep === RegistrationFlowStep.COMPLETE_PROFILE && flowState.needsProfileCompletion && (
                <RegistrationCompletionModal isOpen onSuccess={handleNextStep} onSkip={handleSkipStep} />
            )}

            {flowState.currentStep === RegistrationFlowStep.HOMEMATCH && (
                <RegistrationPreferencesModal isOpen onSuccess={handleNextStep} onSkip={handleSkipStep} />
            )}

            {flowState.currentStep === RegistrationFlowStep.THANK_YOU &&
                (flowState.variant === RegistrationFlowVariant.FAVORITES ? (
                    <RegistrationThankYouFavoritesModal isOpen onClose={handleCloseFlow} />
                ) : (
                    <RegistrationThankYouModal isOpen onClose={handleCloseFlow} />
                ))}
        </>
    );
};
import {useDispatch} from "react-redux";

import {useAppSelector} from "../../store/hooks";
import {closeFlow, nextStep, RegistrationFlowStep, RegistrationFlowVariant, skipCurrentStep} from "../state/registration_flow_slice";
import {RegistrationCompletionModal} from "./registration_flow/RegistrationCompletionModal";
import {RegistrationPreferencesModal} from "./registration_flow/RegistrationPreferencesModal";
import {RegistrationThankYouFavoritesModal} from "./registration_flow/RegistrationThankYouFavoritesModal";
import {RegistrationThankYouModal} from "./registration_flow/RegistrationThankYouModal";

export const RegistrationFlow = () => {
    const dispatch = useDispatch();
    const flowState = useAppSelector((state) => state.registrationFlow);

    if (!flowState.isActive) {
        return null;
    }

    const handleNextStep = () => {
        dispatch(nextStep());
    };

    const handleSkipStep = () => {
        dispatch(skipCurrentStep());
    };

    const handleCloseFlow = () => {
        dispatch(closeFlow());
    };

    return (
        <>
            {flowState.currentStep === RegistrationFlowStep.COMPLETE_PROFILE && flowState.needsProfileCompletion && (
                <RegistrationCompletionModal isOpen onSuccess={handleNextStep} onSkip={handleSkipStep} />
            )}

            {flowState.currentStep === RegistrationFlowStep.HOMEMATCH && (
                <RegistrationPreferencesModal isOpen onSuccess={handleNextStep} onSkip={handleSkipStep} />
            )}

            {flowState.currentStep === RegistrationFlowStep.THANK_YOU &&
                (flowState.variant === RegistrationFlowVariant.FAVORITES ? (
                    <RegistrationThankYouFavoritesModal isOpen onClose={handleCloseFlow} />
                ) : (
                    <RegistrationThankYouModal isOpen onClose={handleCloseFlow} />
                ))}
        </>
    );
};
